import React from 'react';
import RublIcon from '../../../../../../svg/RublIcon';
import Css from './PriceItimMoby.module.css';




function PriceItim(props) {
  function MyRound10(val) {
    return Math.round(Math.ceil(val) / 10) * 10;
  }
  let delprice = true;
  let price = MyRound10(props.price);
  let priceProd;
  if (props.fakprice > price) {
    priceProd = MyRound10(props.fakprice);
  } else {
    priceProd = price;
    if(priceProd == props.saleprice){priceProd = null}
    if (props.saleprice) {
      delprice = true;
    } else { delprice = false; }
  }

  return (
    <div className={Css.contant}>
      {props.saleprice || priceProd}  <RublIcon />
      <span>/м</span>
      {delprice &&
        (
          <span className={Css.delprice}>{priceProd}</span>
        )
      }

    </div>
  );
}

export default PriceItim;